import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FilterBar } from '@bwoty-web/styleguide';
import SelectionBox from '../../shared/filterpanel/SelectionBox';
import * as CruiseListActions from '../../../redux/actions/cruiseListActions';
import {
  filterMatchesSelector,
  filteredCruisePackagesCountSelector,
  filterActiveSelector,
} from '../../../redux/selectors/cruiseList/filterSelectors';
import FilterGroup from './FilterGroup';

const CruiseFilterPanel = (props) => {
  const {
    labels,
    filterPanelIsVisible,
    filterGroups,
    actions,
    filterMatches,
    originalCruisePackagesCount,
    filteredCruisePackagesCount,
    filterActive,
    siteId,
  } = props;

  const [showZeroHitsToolTip, setShowZeroHitsToolTip] = useState(false);

  useEffect(() => {
    if (originalCruisePackagesCount !== 0 && filteredCruisePackagesCount === 0) {
      setShowZeroHitsToolTip(true);
    } else {
      setShowZeroHitsToolTip(false);
    }
  }, [originalCruisePackagesCount, filteredCruisePackagesCount]);

  const filterGroupsMarkup = Object.values(filterGroups).map((filterGroup) => {
    return (
      <FilterGroup
        filterGroup={filterGroup}
        filterActions={actions}
        filterMatches={filterMatches}
        key={filterGroup.order}
        filterPanelIsOpen={filterPanelIsVisible}
        siteId={siteId}
      />
    );
  });

  const numberOfActiveFilters = Object.values(filterActive).filter(isActive => isActive === true).length;

  const buttonLabel = labels.filteredButtonLabel.replace(
    '{filterCount}',
    filteredCruisePackagesCount,
  );

  return (
    <FilterBar
      className="iw-cruise-filter-panel"
      header={labels.filterHeading}
      close={() => actions.toggleFilterPanel(false)}
      closed={!filterPanelIsVisible}
      footer={
        <SelectionBox
          buttonText={buttonLabel}
          clearFilters={() => actions.clearFilters()}
          clearFilterText={labels.clearFilterLabel}
          showClearFiltersButton={!!numberOfActiveFilters}
          disableButton={filteredCruisePackagesCount === 0}
          onClose={() => actions.toggleFilterPanel(false)}
          zeroHitTooltipText={labels.zeroHitTooltipText}
          showZeroHitsToolTip={showZeroHitsToolTip}
          closeZeroHitsToolTip={() => setShowZeroHitsToolTip(false)}
        />
      }
    >
      {filterGroupsMarkup.sort((a, b) => {
        return a.key - b.key;
      })}
    </FilterBar>
  );
};

const mapActions = (dispatch) => {
  return {
    actions: bindActionCreators({ ...CruiseListActions }, dispatch),
  };
};

const mapStateToProps = (state) => {
  const newState = state.toJS();
  return {
    originalCruisePackagesCount: newState.cruises.cruises.length,
    labels: newState.labels,
    filterPanelIsVisible: newState.filter.filterPanelIsVisible,
    filterGroups: newState.filter.filterGroups,
    filterMatches: filterMatchesSelector(newState),
    filteredCruisePackagesCount: filteredCruisePackagesCountSelector(newState),
    filterActive: filterActiveSelector(newState),
    siteId: newState.common.siteSettings.siteId,
  };
};

CruiseFilterPanel.propTypes = {
  labels: PropTypes.shape({
    filterHeading: PropTypes.string.isRequired,
    filteredButtonLabel: PropTypes.string.isRequired,
    clearFilterLabel: PropTypes.string.isRequired,
    zeroHitTooltipText: PropTypes.string.isRequired,
  }).isRequired,
  filterPanelIsVisible: PropTypes.bool.isRequired,
  filterGroups: PropTypes.shape({}).isRequired,
  actions: PropTypes.shape({
    toggleFilterPanel: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
  }).isRequired,
  filterMatches: PropTypes.shape({}).isRequired,
  originalCruisePackagesCount: PropTypes.number.isRequired,
  filteredCruisePackagesCount: PropTypes.number.isRequired,
  filterActive: PropTypes.shape({}).isRequired,
  siteId: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapActions)(CruiseFilterPanel);